module.exports = __webpack_public_path__ + "fonts/BentonSansBBVA-Medium.7263496c.eot";